/* global angular */

export default function($filter) {
  'ngInject';
  return function(items, dict, key, order = 'asc') {
    if (!items) return items;

    const records = Object.keys(items);

    const sorted = $filter('OrderArray')(records, dict, key, order);

    return sorted.reduce((obj, key) => {
      obj[key] = items[key];

      return obj;
    }, {});
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/OrderObject.js